import type { z } from 'zod';

import { schemaEuropaceAngestellter } from './Angestellter.schema';

/*
	https://docs.api.europace.de/privatkredit/vorgaenge/kex-vorgang-import-api/#arbeiter

	{
		"beschaeftigungsverhaeltnis": {
			"arbeitgeber": Firma,
			"berufsbezeichnung": String,
			"befristung": "BEFRISTET" | "UNBEFRISTET",
			"befristetBis": "YYYY-MM-DD",
			"beschaeftigtSeit": "YYYY-MM-DD",
			"inProbezeit": true | false,
			"nettoeinkommenMonatlich": schemaBigDecimal
		},
		"vorherigesBeschaeftigungsverhaeltnis": {
			"arbeitgeber": Firma,
			"beschaeftigtSeit": "YYYY-MM-DD",
			"beschaeftigtBis": "YYYY-MM-DD"
		}
	}

*/

// same schema as Antragsteller, so we reuse it here
export const schemaEuropaceArbeiter = schemaEuropaceAngestellter;
export type SchemaEuropaceArbeiter = z.infer<typeof schemaEuropaceArbeiter>;
